import { Container, AppBar as MuiAppBar, Stack, Toolbar } from "@mui/material";
import { TestEnvBanner, ZfpLogo } from "@zfp-akademie-a-s/zfp-design";
import { DocumentIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { NewAnalysisButton } from "Components/_Shared/Buttons/NewAnalysisButton";
import { DashboardIcon, PersonSearchIcon } from "Components/_Shared/Icons/Icons";
import { Configuration } from "Infrastructure/Config/config";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AdminRouting, AppRouting, getAdminUrl } from "Infrastructure/Utils/UrlUtils";
import type { FC } from "react";
import { UnstyledLink } from "../Routing/UnstyledLink";
import { AppBarMenuItem, type AppBarMenuItemProps } from "./AppBarMenuItem";
import { AppBarUserMenu } from "./AppBarUserMenu";

export const AppBar: FC = () => {
  const isTestEnv = Configuration.getIsTestEnv();
  const { t } = useResource();
  const menuItems: AppBarMenuItemProps[] = [
    {
      name: t(Resources.Dashboard.Title),
      to: AppRouting.Dashboard.path(),
      icon: <DashboardIcon color="secondary" />,
    },
    {
      name: t(Resources.AnalysesListing.Title),
      to: AppRouting.Analyses.path(),
      icon: <DocumentIcon color="secondary" />,
    },
    {
      name: t(Resources.Clients.Title),
      to: getAdminUrl(AdminRouting.ClientContracts.path()),
      target: "_blank",
      icon: <PersonSearchIcon color="secondary" />,
    },
  ];

  return (
    <MuiAppBar position="static">
      {isTestEnv && <TestEnvBanner>{t(Resources.AppBar.TestEnvironment)}</TestEnvBanner>}
      <Toolbar>
        <Container>
          <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <UnstyledLink to="/">
                <ZfpLogo height={32} sx={{ mr: Spacing.XXL }} />
              </UnstyledLink>

              {menuItems.map((item) => (
                <AppBarMenuItem name={item.name} to={item.to} icon={item.icon} target={item.target} key={item.name} />
              ))}
            </Stack>
            <Stack direction={"row"} justifyContent="flex-end" alignItems="center" spacing={Spacing.L}>
              <NewAnalysisButton />
              <AppBarUserMenu />
            </Stack>
          </Stack>
        </Container>
      </Toolbar>
    </MuiAppBar>
  );
};
